<template>
  <div v-if="value" class="dialog__wrapper">
    <div class="dialog">
      <div class="dialog_title">
        手机验绑
      </div>
      <div class="dialog_tishi">
        根据国家国家网信办《移动互联网应用程序信息服务管理规定》注册用户须要求通过手机号码进行实名认证绑定
      </div>
      <div class="mobile_tishi">
        账户绑定的“<span>{{mobile}}</span>"手机信息异常
      </div>
      <div class="mobile_tishi">
        请重新绑定:
      </div>
      <div :class="['mobileInput',mobileClass]">
        <el-input v-model="bindingInfo.mobile" :clearable="true" placeholder="请输入手机号" @focus="mobileFocus" @blur="mobileBlur">
          <template slot="prefix">
            <svg-icon :name="mobileIcon" size="24"></svg-icon>
          </template>
        </el-input>
      </div>
      <div class="input_content">
        <div :class="['codeInput',codeClass]">
          <el-input v-model="bindingInfo.code" :clearable="true" placeholder="请输入验证码" @focus="codeFocus" @blur="codeBlur" ref="codeInput">
            <template slot="prefix">
              <svg-icon :name="codeIcon" size="24"></svg-icon>
            </template>
          </el-input>
          <button class="gainCode" @click="openPt" :style="{background: isSendCode? '#0046b9' : WaitTime < 120? '#dddddd': 'rgba(0,70,185, 0.3)',}">{{ timeIsActive ? "重新获取" + "(" + WaitTime + "S)" : "获取验证码" }}</button>
        </div>
      </div>
      <button class="binding" @click="bidding">
        确认绑定
      </button>
      <validationPT class="setVef" ref="vefCode" @VefCodeTrue="getVefCodeTrue" :inputPhone="bindingInfo.mobile" theme="dialog"></validationPT>

    </div>
  </div>

</template>
<script>
import { fetch, post } from "@/ask/axios";
import validationPT from "../../../../Reception/reg/validationPT.vue";
import bus from "@/ask/eventBus";
import { delCookie } from '@/ask/cookiejs.js'
export default {
  components: {
    validationPT
  },
  data() {
    return {
      bindingInfo: {
        mobile: "",
        code: ""
      },
      mobileIcon: "shoujihao-n",//手机号输入框icon
      codeIcon: "yanzhengma-n",//验证码输入框icon
      mobileClass: "",//手机输入框类名
      codeClass: "",//验证码输入框类名
      WaitTime: 120,
      isMobilePass: false,
    }
  },
  props: {
    value: {},
    isBothBiddingError: {
      type: Boolean
    },
    mobile: {
      type: String,
    }
  },
  watch: {
    value(val) {
      if (val) {
        this.handleOpen();
      } else {
        this.handleClose();
      }
    },
  },

  methods: {
    //确认绑定
    bidding() {
      if (!this.bindingInfo.mobile && this.bindingInfo.code) {
        this.$message.error('请输入手机号')
        this.mobileClass = "borderRed"
        this.isMobilePass = false
        this.mobileIcon = "shoujihao-r"
        return
      } else if (!this.bindingInfo.code && this.bindingInfo.mobile) {
        this.$message.error('请输入验证码')
        this.codeClass = "borderRed"
        this.codeIcon = "yanzhengma-r"
        return
      } else if (!this.bindingInfo.code && !this.bindingInfo.mobile) {
        this.$message.error('请输入手机号和验证码')
        this.codeClass = "borderRed"
        this.codeIcon = "yanzhengma-r"
        this.mobileClass = "borderRed"
        this.isMobilePass = false
        this.mobileIcon = "shoujihao-r"
        return
      }
      // let url = this.$api02 + '/api/EbayCustomer/CustomerInfo/UpdateCustomerPhone';
      let url = this.$api04 + 'Basics/api/CustomerInfo/UpdateCustomerPhone';
      let params = {
        Phone: this.bindingInfo.mobile,
        PhoneCode: this.bindingInfo.code
      }
      post(url, params).then((res) => {
        console.log("确认绑定", res);
        if (res.IsOK) {
          this.handleClose()
        } else {
          this.$message.error(res.Message)
        }
      })
    },
    //获取验证码
    openPt() {
      if (!this.isSendCode || this.timeIsActive) {
        return;
      }
      this.$refs.vefCode.GetSlideBlockApi(); //获取图片
      this.$refs.vefCode.clkOpenRef(); //打开框
      this.$refs["codeInput"].focus();
      this.isMobilePass = false

    },
    // 拼图验证正确回调
    getVefCodeTrue({ MarkCode, LstMouseTrack }) {
      this.pTparams = {
        MarkCode: MarkCode,
        LstMouseTrack: LstMouseTrack,
        mobile: this.bindingInfo.mobile,

      };
      let url = this.$api02 + "/api/EbayCustomer/MobileCode/NewGenerateMobileCodeEditPhone"
      post(url, this.pTparams).then((res) => {
        console.log("Code", res);
        if (res.IsOK) {

        }
      })
      let timer = null;
      if (!timer) {
        timer = setInterval(() => {
          if (this.WaitTime > 0) {
            this.WaitTime--;
          } else {
            clearInterval(timer);
            timer = null;
            this.WaitTime = 120;
          }
        }, 1000);
      }
    },
    //手机号输入框聚焦
    mobileFocus() {
      this.mobileClass = "borderBlue"
      this.mobileIcon = "shoujihao-b"
    },
    // 手机号输入框失焦
    mobileBlur() {
      // let regs = /^((13[0-9])|(19[0-9])|(17[0-1,6-8])|(15[^4,\\D])|(18[0-9]))\d{8}$/;
      let regs = /^1[3,4,5,6,7,8,9][0-9]{9}$/
      if (this.bindingInfo.mobile) {
        if (regs.test(this.bindingInfo.mobile) && this.bindingInfo.mobile.length == 11) {
          // let url = this.$api02 + "/api/EbayCustomer/CustomerRegist/RegistVerify";
          let url = this.$api04+"Basics/api/CustomerRegist/RegistVerify";
          let param = {};
          param.Mobile = this.bindingInfo.mobile;
          post(url, param).then((res) => {
            if (res.IsOK) {
              this.mobileClass = ""
              this.mobileIcon = "shoujihao-n"
              this.isMobilePass = true
            } else {
              this.mobileClass = "borderRed"
              this.isMobilePass = false
              this.mobileIcon = "shoujihao-r"
              this.$message.error("手机号已被绑定使用")
            }
          })
        } else {
          this.mobileClass = "borderRed"
          this.mobileIcon = "shoujihao-r"
          this.$message.error("手机号格式不正确")
          this.isMobilePass = false
        }
      } else {
        this.mobileClass = "borderRed"
        this.mobileIcon = "shoujihao-r"
        this.$message.error("请输入手机号")
        this.isMobilePass = false
      }
    },
    codeFocus() {
      this.codeClass = "borderBlue"
      this.codeIcon = "yanzhengma-b"
    },
    codeBlur() {
      if (this.bindingInfo.code) {
        this.codeClass = ""
        this.codeIcon = "yanzhengma-n"
      } else {
        this.codeClass = "borderRed"
        this.codeIcon = "yanzhengma-r"
        this.$message.error("请输入验证码")
      }

    },
    handleOpen() {
      this.$emit("open");
    },
    // 关闭弹框
    handleClose() {
      delCookie("CustomerInfo")
      localStorage.removeItem("loginMessage")
      localStorage.removeItem("SalesInfos")
      //传过来的值为true说明用户验绑都异常，先打开手机验绑再打开邮箱验绑
      if (this.isBothBiddingError) {
        this.$emit("close", false);
        this.$emit("input", false);
        this.$emit('openEmailDialog', true)

      } else {
        this.$emit("close", false);
        this.$emit("input", false);
      }

    }
  },
  computed: {
    timeIsActive() {
      return this.WaitTime < 120 && this.WaitTime > 0;
    },
    isSendCode() {
      if (this.isMobilePass && !(this.WaitTime < 120 && this.WaitTime > 0)) {
        return true
      } else if (!this.bindingInfo.mobile) {
        return false
      }
    }
  },
}
</script>
<style lang="scss" scoped>
.dialog__wrapper {
  z-index: 10000;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  margin: 0;
  background: rgba(0, 0, 0, 0.24);
}
.dialog {
  position: absolute;
  border-radius: 4px;
  width: 400px !important;
  top: 50%;
  margin-top: -200px;
  height: 384px !important;
  left: 50%;
  margin-left: -192px;
  background: #ffffff;
}
.dialog_title {
  height: 56px;
  border-bottom: solid 1px #f0f0f0;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 56px;
  padding-left: 24px;
  box-sizing: border-box;
}
.dialog_tishi {
  width: 352px !important;
  height: 52px !important;
  background: rgba(0, 70, 185, 0.04);
  border-radius: 4px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #0046b9;
  margin: 16px 24px;
  padding: 9px 8px;
  box-sizing: border-box;
  line-height: 18px;
}
.mobile_tishi {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  height: 20px;
  line-height: 20px !important;
  padding-left: 24px;
  box-sizing: border-box;
  margin-bottom: 8px;
  span {
    color: #d83f3f;
  }
}
.mobileInput {
  width: 352px !important;
  height: 40px !important;
  border-radius: 4px;
  border: 1px solid #dddddd;
  line-height: 38px !important;
  margin: 0 24px 16px;
  transition: border 0.2s;
  &:hover {
    border: 1px solid #aaaaaa;
    transition: border 0.2s;
  }
}
.codeInput {
  width: 224px !important;
  height: 40px !important;
  border-radius: 4px;
  border: 1px solid #dddddd;
  line-height: 38px !important;
  margin: 0 24px 16px;
  transition: border 0.2s;
  &:hover {
    border: 1px solid #aaaaaa;
    transition: border 0.2s;
  }
}
/deep/.el-input {
  height: 40px !important;
}
/deep/ .el-input__inner {
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  height: 40px !important;
  line-height: 40px !important;
  color: #333333;
  border: none;
  padding-left: 36px !important;
}
/deep/ .el-input__suffix {
  line-height: 40px !important;
  height: 40px !important;
  display: flex;
  align-items: center;
}
/deep/ .svgicon {
  position: relative;
  top: 3px;
  left: 2px;
}
.borderBlue {
  border: solid 1px #0046b9 !important;
  transition: all 0.2s;
}
.borderRed {
  border: 1px solid #d83f3f !important;
  transition: all 0.2s;
  ::placeholder {
    color: #d83f3f !important;
  }
}
.binding {
  width: 224px !important;
  height: 40px !important;
  background: #0046b9;
  border-radius: 20px;
  margin: 8px 88px 0;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  outline: none;
  border: none;
  cursor: pointer;
  &:hover {
    background: #2963c4;
    transition: all 0.2s;
  }
  &:active {
    background: #003a9b;
    transition: all 0.2s;
  }
}
.gainCode {
  width: 120px;
  height: 40px;
  background: #0046b9 rgba(255, 255, 255, 0.64);
  border-radius: 4px;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  outline: none;
  cursor: pointer;
  margin-left: 28px;
  border: none;
  position: absolute;
  right: 24px;
  transition: background 0.2s;
}
</style>


// WEBPACK FOOTER //
// src/components/backstageManagement/home/public/bindingDialog/mobileDialog.vue